module.exports = __webpack_public_path__ + "static/media/icon-5.021bbe3a.png";